var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "vue-modal cover flex flex-center" }, [
      _c(
        "div",
        {
          staticClass: "row pop-up",
          style: {
            background: _vm.background,
            width: _vm.width,
            height: _vm.height,
            maxWidth: _vm.maxWidth,
            maxHeight: _vm.maxHeight,
          },
        },
        [
          !_vm.hideClose
            ? _c("header", [
                _c(
                  "div",
                  {
                    staticClass: "close",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.hideModal.apply(null, arguments)
                      },
                    },
                  },
                  [_c("RemovalX")],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("content"),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }